import { useRef, useEffect } from "react";
import { useEvent as o } from "./use-event.js";
let u = Symbol();
function T(t, n = true) {
  return Object.assign(t, { [u]: n });
}
function y(...t) {
  let n = useRef(t);
  useEffect(() => {
    n.current = t;
  }, [t]);
  let c = o((e) => {
    for (let o2 of n.current) o2 != null && (typeof o2 == "function" ? o2(e) : o2.current = e);
  });
  return t.every((e) => e == null || (e == null ? void 0 : e[u])) ? void 0 : c;
}
export {
  T as optionalRef,
  y as useSyncRefs
};
